import { atom } from "recoil";

export const threadPageState = atom({
  key: "THREAD/pages",
  default: 0,
});

export const threadTotalPageState = atom({
  key: "THREAD/total_page",
  default: 1,
});
